'use strict';

var dateFns = require('date-fns');
var parsers = require('../parsers.cjs');

const subMillisecondsToISOTimePart = ({
  isoTimePart,
  duration
}) => {
  const date = parsers.isoTimePartToDate(isoTimePart);
  const result = dateFns.subMilliseconds(date, duration);
  return parsers.dateToISOTimePart(result);
};

module.exports = subMillisecondsToISOTimePart;
//# sourceMappingURL=subMillisecondsToISOTimePart.cjs.map
